/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 登陆状态管理
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-07-12 15:52:52
 * @LastEditTime: 2022-07-18 11:22:53
 * @FilePath: /client-h5-v2/src/store/modules/login.ts
 */

export const login = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  dialog/CLEAR_BTN
  state: {
    status: false,
    userInfo: {
      loginName: ''
    }
  },
  getters: {
    status: (state: any) => state.status,
    userInfo: (state: any) => state.userInfo
  },
  mutations: {
    SET_AGENT_STATUS (state: { status: boolean }, data: boolean) {
      state.status = data
    },
    SET_USER_INFO (state: { userInfo: any }, data: any) {
      state.userInfo = data
    }
  },
  actions: {
  }
}
